export default __webpack_public_path__ + "static/media/image19.b2157d4e.jpg";